import './login.scss';

import React, { useEffect } from 'react';
import SsoAuth from 'app/modules/user/ui/mobile/sso/sso.auth';
import { getDocCMS } from 'app/modules/cms/service/cmsService';
import { useDispatch, useSelector } from 'react-redux';
import { getSigninSelector } from 'app/modules/cms/service/store/selectors';
import { getRulesDataByKey } from 'app/modules/rules/service/store/selectors';
import { RulesKeys } from 'app/modules/rules/domain/rules.keys';


export const Login = () => {
  const dispatch = useDispatch();
  const signinCmsData: any = useSelector(getSigninSelector);
  const getConf = useSelector(getRulesDataByKey(RulesKeys.GET_CONF));
  useEffect(() => {
    dispatch(getDocCMS('mobile_signin_page'));
  }, []);
  return (
    <>
      <SsoAuth dataInfoCms={signinCmsData} dataConf={getConf?.composeApp?.LOGIN}/>
    </>
  );
};
